import DOMPurify from 'dompurify'
import parse from 'html-react-parser'
import { memo, type ReactNode, useMemo } from 'react'

import { cn } from '@/lib/utils'

export interface AgentReportHtmlContentProps {
  html: string
  className?: string
}

const SANITIZE_OPTIONS = {
  USE_PROFILES: { html: true },
  ADD_TAGS: ['table', 'thead', 'tbody', 'tr', 'th', 'td', 'caption'],
}

const AgentReportHtmlContentBase: React.FC<AgentReportHtmlContentProps> = ({
  html,
  className,
}): ReactNode => {
  const sanitized = useMemo(() => DOMPurify.sanitize(html, SANITIZE_OPTIONS), [html])
  if (!sanitized) {
    return null
  }
  return <div className={cn('agent-report-html saaga-wysiwyg', className)}>{parse(sanitized)}</div>
}

export const AgentReportHtmlContent = memo(AgentReportHtmlContentBase)

AgentReportHtmlContent.displayName = 'AgentReportHtmlContent'
